<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on: menu }">
      <v-btn dark small depressed color="primary" v-on="{ ...menu }" :loading="loading">
        <v-icon small class="mr-1">mdi-calendar</v-icon> Período
      </v-btn>
    </template>
    <v-list>
      <v-list-item @click="loadOrdersByPeriod(7)">
        <v-list-item-title>7 dias</v-list-item-title>
      </v-list-item>
      <v-list-item @click="loadOrdersByPeriod(15)">
        <v-list-item-title>15 dias</v-list-item-title>
      </v-list-item>
      <v-list-item @click="loadOrdersByPeriod(30)">
        <v-list-item-title>30 dias</v-list-item-title>
      </v-list-item>
      <v-list-item @click="loadOrdersByPeriod(90)">
        <v-list-item-title>Trimestre</v-list-item-title>
      </v-list-item>
      <v-list-item @click="loadOrdersByPeriod(180)">
        <v-list-item-title>Semestre</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    loading: Boolean,
  },
  methods: {
    loadOrdersByPeriod(time) {
      this.$emit('click', time)
    },
  },
}
</script>

<style></style>
